/*
  The Connected Dot -- Transparency & Technology page.
  Adapted from a standalone HTML export (Claude Projects/sub pages/final
  pages/transparency-and-technology.html) for
  sections/transparency-and-technology.liquid.

  Two changes from the original export:
  1. The ring gallery's image list used bare "assets/xxx.jpg" string literals
     (a JS file can't run Liquid's asset_url filter). ASSETS_BASE is set by an
     inline script in the section from Shopify's asset_url and prefixed onto
     each filename at runtime, same technique used on Station Atlas/About Us.
  2. #pillnav is fixed positioned and has no awareness of where this
     section's own content ends, so it's faded out once the reader scrolls
     into the theme's footer (see assets/how-we-build-better-fibres.js /
     assets/care-and-guarantee.js for the same pattern) rather than floating
     on top of footer content.
*/
(function(){
  'use strict';
  const ASSETS_BASE = window.__RD_DOT_ASSETS_BASE__ || '';
  const $=s=>document.querySelector(s), $$=s=>document.querySelectorAll(s);

  /* hero dot ping */
  const hd=$('#herodot');
  function ping(){ hd.classList.remove('pinging'); void hd.offsetWidth; hd.classList.add('pinging'); }
  hd.addEventListener('click',ping);
  hd.addEventListener('mouseenter',ping);
  setInterval(ping, 6000); setTimeout(ping, 800);

  /* ring build */
  const items=[
    ['merino.jpg','01 · <b>grown</b> — merino, NZ high country','Grown','Merino grown on regenerative high-country stations in New Zealand. The dot logs the exact farm your fibre came from.'],
    ['farm.jpg','01 · <b>grown</b> — regenerative stations','Regenerative stations','ZQ-certified stations in the top 1% of farms for animal welfare and land management — logged at origin.'],
    ['fleece.jpg','01 · <b>shorn</b> — welfare first, always','Shorn','Welfare first, always. Shearing is recorded, and the fleece is tracked from the moment it leaves the sheep.'],
    ['20241211_143944000_ios.jpg','02 · <b>spun</b> — fibre becomes yarn','Spun','Raw fibre is scoured and spun into yarn. The dot follows every batch as it changes hands.'],
    ['spin.jpg','02 · <b>spun</b> — batch tracked at the mill','At the mill','Which mill, which process, which batch — all tracked, so nothing disappears into the supply chain.'],
    ['_ew86080.jpg','03 · <b>knitted</b> — yarn becomes garment','Knitted','Yarn is knitted into panels and garments, with the makers and their standards on record.'],
    ['dsc00954.jpg','03 · <b>knitted</b> — every cone accounted for','Every cone accounted for','Each cone of yarn is accounted for as it becomes your garment — traceable, never anonymous.'],
    ['_ew85806.jpg','04 · <b>finished</b> — checked &amp; pressed','Finished','Every garment is finished and quality-checked before it earns its Connected Dot.'],
    ['chip.jpg','04 · <b>dotted</b> — identity issued','Dotted','This is the moment your knit gets its living digital identity, linked to everything before it.'],
    ['shipping.jpg','05 · <b>shipped</b> — the last leg, counted','Shipped','Even the last leg to your door is mapped and counted — visibility creates accountability.'],
    ['care.jpg','06 · <b>worn</b> — care via the dot','Worn','The dot gives you care guidance tailored to your knit, so it stays soft for decades, not seasons.'],
    ['repair.jpg','07 · <b>repaired</b> — logged at the Knit Clinic','Repaired','Snags happen. Repairs through the Knit Clinic are logged into your garment’s ongoing history.'],
  ];
  const ring=$('#ring'), cap=$('#ringcap');
  const capDefault='Tap the pictures';
  items.forEach((it,i)=>{
    const d=document.createElement('div');
    d.className='ritem';
    d.style.setProperty('--a',(i*360/items.length)+'deg');
    d.style.animationDelay=(-120*i/items.length)+'s';
    const src=ASSETS_BASE+it[0];
    d.innerHTML='<div class="rimg"><img src="'+src.replace(/"/g,'&quot;')+'" alt="" loading="lazy"></div>';
    d.addEventListener('mouseenter',()=>{cap.innerHTML=it[1];});
    d.addEventListener('mouseleave',()=>{cap.textContent=capDefault;});
    d.addEventListener('click',()=>{openModal(src,it[2],it[3]);});
    ring.appendChild(d);
  });

  /* popup modal */
  const modal=$('#modal'),mImg=$('#modalImg'),mTitle=$('#modalTitle'),mBody=$('#modalBody');
  function openModal(src,title,body){
    mImg.src=src; mImg.alt=title||''; mTitle.textContent=title||''; mBody.textContent=body||'';
    modal.classList.add('open'); modal.setAttribute('aria-hidden','false');
  }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); }
  $('#modalClose').addEventListener('click',closeModal);
  modal.addEventListener('click',e=>{ if(e.target===modal) closeModal(); });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeModal(); });

  /* hero inline images open the modal (data-img is already a full asset_url from Liquid) */
  $$('.bigline .inl').forEach(el=>{
    el.addEventListener('click',()=>{
      openModal(el.dataset.img, el.dataset.title, el.dataset.body);
    });
  });

  /* index drawers */
  $$('.irow').forEach(row=>{
    row.addEventListener('click',()=>{
      const id=row.dataset.drawer, dr=document.getElementById(id);
      const wasOpen=dr.classList.contains('open');
      $$('.drawer').forEach(d=>d.classList.remove('open'));
      $$('.irow').forEach(r=>r.classList.remove('active'));
      if(!wasOpen){ dr.classList.add('open'); row.classList.add('active'); }
    });
  });
  /* hanging cards open their row */
  $$('.hang .card').forEach(c=>{
    c.addEventListener('click',()=>{
      const dr=document.getElementById(c.dataset.row);
      const row=$('.irow[data-drawer="'+c.dataset.row+'"]');
      $$('.drawer').forEach(d=>d.classList.remove('open'));
      $$('.irow').forEach(r=>r.classList.remove('active'));
      dr.classList.add('open');
      if(row) row.classList.add('active');
      dr.scrollIntoView({behavior:'smooth',block:'center'});
    });
  });

  /* reveal */
  const io=new IntersectionObserver(es=>{
    es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); }});
  },{threshold:.2});
  $$('.rv').forEach(el=>io.observe(el));

  /* #pillnav fade -- see the header comment above */
  (function syncPillNav(){
    const wrapper = document.querySelector('.rd-dot');
    if (!wrapper) return;
    let ticking = false;
    function apply(){
      const vh = window.innerHeight;
      const released = wrapper.getBoundingClientRect().bottom <= vh;
      wrapper.classList.toggle('past-end', released);
      ticking = false;
    }
    apply();
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    window.addEventListener('resize', apply);
  })();

})();
